import React, { useEffect } from "react";
import { observer } from "mobx-react";
import TopCheerList from "../../Cheer/TopCheerList";
import TopCheersBottomBar from "./TopCheersBottomBar";
import Scrollbar from "../../ui/Scrollbar";
import style from "./TopCheerersTab.module.scss";
import useCheersStore from "../../../../../common/hooks/useCheersStore";
import { REFRESH_INTERVAL } from "../../../../../common/constants/refreshInterval";
import Loader from "../../../../../common/components/Loader";
import { getCheerersPeriod } from "../../../../../common/constants/getCheerersPeriod";
import GA from "../../../../../common/services/GA";

const TopCheerersTab: React.FC = observer(() => {
  const cheersStore = useCheersStore();
  const { cheerers, error } = cheersStore.cheerersList;

  useEffect(() => {
    cheersStore.getCheerers();

    const interval = setInterval(() => {
      cheersStore.getCheerers();
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [cheersStore, cheersStore.cheerersListPeriod]);

  const renderContent = (): React.ReactNode => {
    if (error) return <div className={style.topCheerersTab__warningInfo}>{error.message}</div>;

    if (!cheerers)
      return (
        <div className={style.topCheerersTab__warningInfo}>
          <Loader />
        </div>
      );

    if (cheerers.length === 0) return <div className={style.topCheerersTab__warningInfo}>No cheerers yet!</div>;

    return (
      <Scrollbar>
        <TopCheerList
          data={cheerers.map((cheerer) => {
            return {
              title: cheerer.username,
              amount: cheerer.bitsSum,
            };
          })}
        />
      </Scrollbar>
    );
  };

  const onButtonClick = (cheerersListPeriod: getCheerersPeriod): void => {
    cheersStore.setCheerersListPeriod(cheerersListPeriod);
    GA.sendEvent("click", "cheerleaders_period_click", cheerersListPeriod);
  };

  return (
    <div className={style.topCheerersTab}>
      <div className={style.topCheerersTab__content}>{renderContent()}</div>
      <div className={style.topCheerersTab__bottomBar}>
        <TopCheersBottomBar
          onButtonClick={(cheerersListPeriod) => onButtonClick(cheerersListPeriod)}
          cheerersListPeriod={cheersStore.cheerersListPeriod}
        />
      </div>
    </div>
  );
});

export default TopCheerersTab;
